import { useLocales } from '@/locales';
import { LomavisDateRangeInput1 } from '@/lomavisSharedUi/atoms/inputs/LomavisRangeCalendar1';
import React from 'react';

interface Props {
  setDate: (date) => void;
}

const CommonHeader: React.FC<Props> = ({ setDate }) => {
  const { currentLang } = useLocales();
  return (
    <div className="w-100 d-flex justify-content-end">
      <div>
        <LomavisDateRangeInput1
          currentLang={currentLang}
          defaultIndex={2}
          demo={false}
          allowCurrentDay={false}
          setDates={(value) => {
            setDate(value);
          }}
        />
      </div>
    </div>
  );
};

export default CommonHeader;
